import React from "react";
import { Button, useDataProvider, useRecordContext, useRefresh, useListContext } from "react-admin";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const MoveButton = ({ direction }) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const record = useRecordContext();
  const { data, total, page, perPage } = useListContext();

  const sortedData = data.sort((a, b) => a.display_order - b.display_order);

  const currentIndexInPage = sortedData.findIndex(item => item.id === record.id);

  const isFirst = (page === 1) && (currentIndexInPage === 0);
  const isLast = (page * perPage - perPage + currentIndexInPage + 1) === total;

  if ((direction === "up" && isFirst) || (direction === "down" && isLast)) {
    return null; // Do not render if first or last globally
  }

  const handleMove = async () => {
    if (!record) return;
    try {
      await dataProvider.customQuery({
        query: `
          mutation moveCause($p_id: uuid!, $p_direction: String!) {
            move_cause_display_order(args: { p_id: $p_id, p_direction: $p_direction }) {
              id
              display_order
            }
          }
        `,
        variables: {
          p_id: record.id,
          p_direction: direction,
        },
      });
      refresh();
    } catch (error) {
      console.error("Error moving record:", error);
    }
  };

  return (
    <Button onClick={handleMove}>
      {direction === "up" ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
    </Button>
  );
};

export default MoveButton;
